<script setup>
    import { useRouter,useRoute } from 'vue-router'
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    });
    
    const router = useRouter();

    const search = ref("");
    const onSearch = ()=>{
        if(search.value.length <= 0){
            ElMessage.error("请输入搜索内容");
            return false;
        }

        router.push({
            path: '/search/index',
            query: { q: search.value }
        });
        
        return true;
    }
</script>

<template>
    <div class="search">
        <div class="logo">
            <a-link :to="props.data.path"><img :src="props.data.logo" /></a-link>
        </div>
        <div class="search-box">
            <input type="text" v-model="search" :placeholder="props.data.text" />
            <span @click="onSearch">搜索</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.search {
    width: 1200px;
    height: 92px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .logo {
        img {
            height: 92px;
            cursor: pointer;
        }
    }
    .search-box {
        position: relative;
        margin-top: 22px;
        width: 800px;
        input {
            width: 800px;
            height: 41px;
            border: 1px solid #dc143c;
            border-radius: 5px;
            position: absolute;
            z-index: 1;
            text-indent: 15px;
            &::placeholder {
                color: #999;
                font-size: 15px;
                text-indent: 15px;
            }
        }
        span {
            position: absolute;
            top: 3px;
            right: 5px;
            z-index: 2;
            width: 73px;
            height: 35px;
            line-height: 35px;
            text-align: center;
            border-radius: 10px;
            background-color: #dc143c;
            font-size: 16px;
            color: #fff;
            cursor: pointer;
            &:hover {
                opacity: 0.8;
            }
        }
    }
}
</style>